<template>
  <div class="bridge8-harmonica">
    <div
      v-for="(group, i) in groups"
      :key="i"
      class="bridge8-harmonica-group-wrapper mr-2"
    >
      <div
        class="d-flex flex-row justify-content-between px-2 py-1 m-0 mt-2 mb-2 border bridge8-harmonica-toggler"
        :class="{ 'active': panesState[i] }"
        @click="onTogglerClicked(i)"
      >
        <span>{{ group.label }}</span>
        <span>{{ `(${group.rels.length} relationship${group.rels.length > 1 ? 's' : ''})` }}</span>
      </div>
      <div
        v-if="panesState[i]"
        class="bridge8-harmonica-pane"
      >
        <ul class="list-unstyled bridge8-harmonica-pane-list">
          <li
            v-for="(rel, j) in group.rels"
            :key="j"
            :class="{ 'active': determineActiveItem(rel) }"
            @click="selectItem(rel)"
          >
            <div class="d-flex flex-row justify-content-between align-content-center">
              <div>{{ rel.node.name || (rel.node.created && formatDateTime(rel.node.created)) || '--- n/a ---' }}</div>
              <div
                v-if="determineActiveItem(rel)"
                class="d-flex flex-row bridge8-harmonica-pane-list-item-buttons mr-2"
              >
                <a class="mr-1" title="Add this related Node to Cart" @click="addRelatedNodeToCart(rel.node)">
                  <mdb-icon icon="shopping-cart" />
                </a>
                <a class="mr-1" title="Go to this Node" @click="gotoLabelNode(group.label, rel.node)">
                  <mdb-icon icon="external-link-square-alt" />
                </a>
                <a v-if="!readOnly" title="Delete this Relationship" @click="deleteRelationship(rel.uuid, group)">
                  <mdb-icon style="color: coral;" icon="trash" />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {formatDT, tableValues} from '../utils'
import {mdbBtn, mdbIcon, mdbPopover, mdbTbl, mdbTblBody} from 'mdbvue'

export default {
  name: 'AdminTabNodeRelationshipsNodesHarmonica',
  data () {
    return {
      panesState: null,
      itemSelected: null
    }
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    determineActiveItem (rel) {
      return (this.itemSelected && rel) ? this.itemSelected.uuid === rel.uuid : false
    },
    formatDateTime (dtObj) {
      return formatDT(dtObj)
    },
    onTogglerClicked (num) {
      this.panesState[num] ? this.$set(this.panesState, num, false) : this.$set(this.panesState, num, true)
      if (
        this.panesState[num] === false &&
        this.groups[num].rels.includes(this.itemSelected)
      ) {
        this.selectItem(null)
      }
    },
    getTableValues (obj) {
      return tableValues(obj, true)
    },
    selectItem (item) {
      this.itemSelected = item
      this.$emit('select', item)
    },
    gotoLabelNode (label, node) {
      this.$bus.$emit('admin-goto', {label: label, node: node})
    },
    deleteRelationship (relUuid, group) {
      const isLast = group.rels.length === 1
      this.$emit('delete-relationship', {uuid: relUuid, isLast: isLast})
    },
    addRelatedNodeToCart (relNode) {
      this.$bus.$emit('admin-cart-add-node', relNode)
    }
  },
  mounted () {
    this.panesState = Array(this.groups.length).fill(false)
    this.$bus.$on('admin-select-related-node-by-rel-uuid', uuid => {
      const groupIndex = this.groups.findIndex(group => group.rels.map(rel => rel.uuid).includes(uuid))
      this.panesState[groupIndex] = true
      const item = this.groups[groupIndex].rels.find(rel => rel.uuid === uuid)
      this.selectItem(item)
    })
  },
  beforeDestroy () {
    this.$bus.$off('admin-select-related-node-by-rel-uuid')
  },
  watch: {
    groups: {
      handler (newVal, oldVal) {
        this.selectItem(null)
        this.panesState = Array(this.groups.length).fill(false)
      },
      deep: true
    }
  },
  components: {
    mdbBtn, mdbIcon, mdbPopover, mdbTbl, mdbTblBody
  }
}
</script>

<style lang="sass" scoped>
.bridge8-harmonica
  overflow-y: scroll

  .bridge8-harmonica-group-wrapper
    .bridge8-harmonica-toggler
      cursor: pointer

      &.active
        background-color: adjust_color(darkcyan, $alpha: -0.9)

    .bridge8-harmonica-pane
      .bridge8-harmonica-pane-list
        li
          font-size: small

          &.active
            font-weight: bold

            & > div
              background-color: adjust_color(darkcyan, $alpha: -0.7)

          & > div
            border-radius: 0.3em
            padding: 0.2em 0.2em 0.2em 0.5em
            cursor: pointer
            text-align: start
            white-space: nowrap

          .bridge8-harmonica-pane-list-item-buttons
            a:hover
              font-size: 130%
</style>



// WEBPACK FOOTER //
// src/components/AdminTabNodeRelationshipsNodesHarmonica.vue